import React from "react";

const Footer = () => {
  return (
    <footer className="page_footer">
      <a
        href={process.env.REACT_APP_SV_URL}
        aria-label="Tillbaka till Studieförbundet Vuxenskolan"
      >
        <img src="/gissa-partiet/mittval_logo1.png" alt="" />
      </a>
      <a
        href="https://www.mucf.se/"
        aria-label="MUCF - Myndigheten för ungdoms- och civilsamhällesfrågor"
      >
        <img src="/gissa-partiet/mucf-projektstampel.png" alt="" />
      </a>
    </footer>
  );
};

export default Footer;
